import { jsx as c } from "react/jsx-runtime";
import { createContext as a, useContext as o, useState as P, useCallback as x } from "react";
const l = a(
  void 0
);
function v({
  children: t,
  pageProps: n
}) {
  return /* @__PURE__ */ c(l.Provider, { value: n, children: t });
}
function C() {
  return o(l);
}
const r = a(null);
function k({
  children: t
}) {
  const [n, g] = P(() => /* @__PURE__ */ new Map()), f = x((s, i) => {
    g((e) => {
      if (e.get(s) === i) return e;
      const u = new Map(e);
      return u.set(s, i), u;
    });
  }, []);
  return /* @__PURE__ */ c(r.Provider, { value: { signals: n, setSignal: f }, children: t });
}
function m(t) {
  const n = o(r);
  if (n)
    return n.signals.get(t);
}
const S = () => {
};
function B() {
  const t = o(r);
  return t ? t.setSignal : S;
}
export {
  k as BlockSignalsProvider,
  v as PagePropsProvider,
  m as useBlockSignal,
  C as usePageProps,
  B as useSetBlockSignal
};
